// src/components/comments/AddCommentForm.tsx
import React from 'react';
import { type RecipeComment } from '../../api/Types';
import { useAuth } from '../../context/AuthContext';
import { useAddCommentForm } from '../../domains/comments';
import { Alert, Box, Button, Flex, Spinner, Text, Textarea } from '../ui';

interface AddCommentFormProps {
  recipeId: string;
  onCommentAdded?: (comment: RecipeComment) => void; // Made optional
}

const AddCommentForm: React.FC<AddCommentFormProps> = ({ recipeId, onCommentAdded }) => {
  const { author, token } = useAuth();
  const {
    comment,
    submitting,
    error,
    setComment,
    handleSubmit,
  } = useAddCommentForm({
    recipeId,
    authorId: author?.id,
    token,
  });

  if (!author) {
    return <Text tone="muted">Vous devez être connecté pour laisser un commentaire.</Text>;
  }

  return (
    <Flex className="comment-input-area" marginTop={4} padding={3} align="center">
      <Flex as="form" onSubmit={handleSubmit} fullWidth align="start" marginBottom={3}>
        <Box flexGrow marginEnd={2}>
          <Textarea
            className="comment-textarea"
            rows={1} // Single row for chat-like input
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Message..."
            required
          />
        </Box>
        <Button
          type="submit"
          variant="success"
          radius="circle"
          className="comment-send-button"
          disabled={submitting}
        >
          {submitting ? (
            <Spinner as="span" size="sm" variant="light" label="Envoi du commentaire..." aria-hidden="true" />
          ) : (
            '➔' // Unicode right arrow character
          )}
        </Button>
      </Flex>
      {error && <Alert variant="danger" fullWidth marginTop={2}>{error}</Alert>}
    </Flex>
  );
};

export default AddCommentForm;
